<section>
  <h4 class="mb-3"
      *ngIf="showHeader">{{ title }}</h4>

  <div class="choose-delivery-tabs"
       [class.more-than-two]="deliveryOptions.length > 2">
    <ui-btn-two-lines
      *ngFor="let option of deliveryOptions"
      [class.pointer-events-none]="isBlocked(option.type)"
      [icon]="option.icon"
      [title]="option.title"
      [disabled]="isBlocked(option.type)"
      [btnColor]="btnColor"
      [info]="option.info"
      [extraClasses]="extraBtnClasses + (deliveryType == option.type ? ' selected' : '')"
      (click)="updateDeliveryType(option.type)"
    ></ui-btn-two-lines>
  </div>
</section>
